import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {ModalService} from "angular-modal-simple";
import {Person} from "../../shared/types/types";

@Component({
  selector: 'app-person-modal',
  templateUrl: './person-modal.component.html',
  styleUrls: ['./person-modal.component.scss']
})
export class PersonModalComponent implements OnInit, OnDestroy {
  @Input() person:  Person | undefined;

  @HostListener('window:popstate', ['$event'])
  onPopState() {
    this.modalService.closeAll();
  }

  constructor(private router: Router, private modalService: ModalService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.router.navigate(['/munkatarsaink']);
  }


}
